import React from "react";
import {
  BooleanField,
  Datagrid,
  DateField,
  DeleteButton,
  FunctionField,
  Link,
  Pagination,
  ReferenceManyField,
  TextField,
  useGetManyReference,
  useRecordContext,
  useRefresh,
} from "react-admin";
import { Typography } from "@mui/material";

const GetInvitations = ({ reference = "onpoint_extraction_software_invitation" }) => {
  const record = useRecordContext();
  const refresh = useRefresh();
  const { data, isLoading } = useGetManyReference(reference, {
    target: 'master_customer_id',
    id: record?.id,
    pagination: { page: 1, perPage: 10 },
    sort: { field: 'id', order: 'DESC' },
  });

  if (isLoading) return null;

  if (!data || data.length === 0) {
    return <Typography sx={{ m: 2 }}>No OnPoint invitations found</Typography>;
  }

  return (
    <ReferenceManyField
      fullWidth
      label="Invitations"
      reference={reference}
      target="master_customer_id"
      source="id"
      perPage={10}
      sort={{ field: "id", order: "DESC" }}
      pagination={<Pagination />}
    >
      <Datagrid>
        <TextField source="id" label="ID" />
        <DateField
          source="date_added"
          label="Date Added"
          showTime
        />
        <TextField source="added_by" label="Added By" />
        <FunctionField label="Invite Link" render={record => (
          <Link to={`/extraction_software_registration?extraction_software_registration_token=${record.extraction_software_registration_token}`} style={{ color: 'grey' }}>Invite</Link>
        )} />
        <TextField source="status" />
        <TextField source="invitation_email_send_to" label="Invitation Email" />
        <BooleanField source="accepted_center_store_participation" label="Accepted Center Store Participation" />
        <BooleanField source="interested_in_patron_points_tobacco" label="Interested in Patron Points Tobacco" />
        <BooleanField source="accepted_eula" label="Accepted EULA" />
        <DateField
          source="registration_completed_date"
          label="Registration Completed Date"
          showTime
        />
        <DeleteButton redirect={false} mutationMode="pessimistic" mutationOptions={{ onSuccess: () => refresh() }} />
      </Datagrid>
    </ReferenceManyField>
  );
};

export default GetInvitations;
